import { render, staticRenderFns } from "./ControllerAwards.vue?vue&type=template&id=751a1bf6&scoped=true&"
import script from "./ControllerAwards.vue?vue&type=script&lang=js&"
export * from "./ControllerAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a1bf6",
  null
  
)

export default component.exports